export default "__VITE_ASSET__DkrIvBqS__"